import { RefObject, useEffect, useState } from 'react';

import { GoogleMapProps } from '../types';

export const useMap = (ref: RefObject<HTMLDivElement | null>, options: GoogleMapProps) => {
  const [map, setMap] = useState<google.maps.Map>();

  const { center, onClick, zoom } = options;

  useEffect(
    function setMapOptions() {
      map?.setOptions(options);
    },
    [map, options]
  );

  useEffect(
    function initializeMap() {
      if (!ref?.current || map) {
        return;
      }

      setMap(new window.google.maps.Map(ref.current, { center, zoom, mapTypeId: google.maps.MapTypeId.SATELLITE }));
    },
    [ref, map]
  );

  useEffect(
    function registerMapClickListener() {
      if (!map) {
        return;
      }

      google.maps.event.clearListeners(map, 'click');

      if (onClick) {
        map.addListener('click', onClick);
      }

      return () => google.maps.event.clearListeners(map, 'click');
    },
    [map, onClick]
  );

  return map;
};
